import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { SimpleIndexedDBService } from '../services/simple-indexeddb.service';
import { environment } from '../../environments/environment';
import { UserProfile } from './IUserProfile';
import { AuthServiceProvider } from '../users/auth-service/auth-service';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UserProfileService  {
  private _userProfile = new BehaviorSubject<UserProfile | null>(null);
  private _secondaryToken = new BehaviorSubject<string | null>(null);
  private readonly LOCAL_STORAGE_PROFILE_KEY = '_ionicstorage/_ionickv/idToken';
  public userProfile: UserProfile;

  constructor(
    public httpClient: HttpClient,
    private indexedDB: SimpleIndexedDBService,
    public authService: AuthServiceProvider
  ) {}

  get profile$(): Observable<UserProfile | null> {
    return this._userProfile.asObservable();
  }

  getUserProfile() {
    if (this.userProfile == null) {
      this.setUserProfile();
      console.log('getUserProfile:', this._userProfile);
      this.userProfile = this._userProfile.value;
      return this._userProfile;
    } else {
      this.profile$.subscribe((profile) => {
        this.userProfile = profile;
      });
      return this._userProfile;
    }
  }

  getSecondaryToken(user: any): Promise<void> {
    console.log('environment authUrl', environment.authUrl);
    const url = `${environment.authUrl}/generate-token/${user.agency}`;

    return new Promise((resolve, reject) => {
      this.httpClient.get<SecondaryTokenResponse>(url).subscribe({
        next: (response) => {
          this._secondaryToken.next(response.token);
          console.log("new idToken: ", response.token);
          this.indexedDB.setItem('idToken', response.token);
          this.setUserProfile();
          resolve();
        },
        error: (error) => {
          console.error('Error fetching secondary token:', error);
          reject(error);
        }
      });
    });
  }

  setUserProfile(): Observable<UserProfile> {
    //let token = window.localStorage.getItem(this.LOCAL_STORAGE_PROFILE_KEY);
  // let token = window.localStorage.getItem(this.LOCAL_STORAGE_MAIN_KEY);
  //   if (token && token.startsWith('"') && token.endsWith('"')) {
  //     token = token.slice(1, -1);
  //   }

    const url = `${environment.staffUrl}GetStaffInfo`;
    //const requestBody = { token: token };

    return this.httpClient.get<UserProfile>(url).pipe(
      tap((response) => {
        this._userProfile.next(response);
        console.log('Secondary Token - User profile response:', response);
      }),
      catchError((error) => {
        console.error('Error fetching secondary token:', error);
        if (error.status === 401) {
          this.authService.signOut();
        } else {
          this._userProfile.next(null);
        }
        return throwError(() => error);
      })
    );
  }

}
